export const letterWidth = 8.5;
